import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LightboxModule } from 'ngx-lightbox';
import { NgImageSliderModule } from 'ng-image-slider';
import { IvyCarouselModule } from 'angular-responsive-carousel';

import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ServicesComponent } from './programs/services.component';
import { FaqComponent } from './faq/faq.component';
import { BlogComponent } from './blog/blog.component';
import { ContactComponent } from './contact/contact.component';
import { PricingComponent } from './pricing/pricing.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';

import { GalleryComponent } from './gallery/gallery.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NguCarouselModule } from '@ngu/carousel';
import { RouterModule } from '@angular/router';
import { CurriculumJavaScriptComponent } from './curriculum/curriculum-js-dev/curriculum-java-script.component';
import { CurriculumUxDesignComponent } from './curriculum/curriculum-ux-design/curriculum-ux-design.component';
import { CurriculumJavaComponent } from './curriculum/curriculum-java/curriculum-java.component';
import { SharedModule } from '../../shared/shared.module';
import { TypingAnimationModule } from 'angular-typing-animation';
import { CurriculumInDevelopmentComponent } from './curriculum/curriculum-in-development/curriculum-in-development.component';
import { BlogListComponent } from './blog/blog-list.component';
import { WebinarsListComponent } from './webinars/webinars-list.component';
import { WebinarComponent } from './webinars/webinar.component';
import { TutorsApplySectionComponent } from './contact/tutors-apply-section.component';

@NgModule({
  declarations: [
    HomeComponent,
    AboutComponent,
    ServicesComponent,
    FaqComponent,
    BlogComponent,
    ContactComponent,
    PricingComponent,
    TestimonialsComponent,
    GalleryComponent,
    CurriculumJavaScriptComponent,
    CurriculumUxDesignComponent,
    CurriculumJavaComponent,
    CurriculumInDevelopmentComponent,
    BlogListComponent,
    WebinarsListComponent,
    WebinarComponent,
    TutorsApplySectionComponent
  ],
  exports: [
    HomeComponent,
    AboutComponent,
    ServicesComponent,
    FaqComponent,
    BlogComponent,
    ContactComponent,
    PricingComponent,
    TestimonialsComponent,
    NgbModule,
    BlogListComponent,
    WebinarsListComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    LightboxModule,
    NgImageSliderModule,
    IvyCarouselModule,
    NguCarouselModule,
    NgbModule,
    SharedModule,
    TypingAnimationModule
  ]
})
export class SectionsModule {}
